var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.75vw",
    height: "2.5vh",
    viewBox: "0 0 1 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95754 17.792C8.7404 17.792 9.37504 17.1574 9.37504 16.3745C9.37504 15.5917 8.7404 14.957 7.95754 14.957C7.17468 14.957 6.54004 15.5917 6.54004 16.3745C6.54004 17.1574 7.17468 17.792 7.95754 17.792Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 17.792C14.9162 17.792 15.5508 17.1574 15.5508 16.3745C15.5508 15.5917 14.9162 14.957 14.1333 14.957C13.3505 14.957 12.7158 15.5917 12.7158 16.3745C12.7158 17.1574 13.3505 17.792 14.1333 17.792Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67183 5.12933L6.34683 10.4327C6.60433 11.2477 6.73266 11.6552 6.98016 11.9568C7.19683 12.2235 7.47933 12.4293 7.7985 12.5568C8.161 12.701 8.58766 12.701 9.44266 12.701H12.6552C13.5102 12.701 13.9368 12.701 14.2985 12.5568C14.6185 12.4293 14.9002 12.2235 15.1177 11.9568C15.3643 11.6552 15.4927 11.2477 15.751 10.4327L16.0918 9.35266L16.2918 8.71433L16.5677 7.83933C16.6661 7.52725 16.6896 7.19637 16.6364 6.8735C16.5831 6.55062 16.4545 6.24484 16.261 5.98092C16.0675 5.71701 15.8146 5.50238 15.5227 5.35443C15.2309 5.20647 14.9082 5.12936 14.581 5.12933H4.67183ZM4.67183 5.12933L4.66266 5.0985C4.62747 4.98063 4.58857 4.8639 4.546 4.7485C4.37729 4.32145 4.09119 3.95085 3.72077 3.67952C3.35034 3.40819 2.91071 3.2472 2.45266 3.21516C2.36683 3.2085 2.27266 3.2085 2.0835 3.2085",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.42a256efcba5b07890fd266854cdbe84.svg";
export { ForwardRef as ReactComponent };